module.exports = __webpack_public_path__ + "img/palette.24833af9.svg";